module.exports = __webpack_public_path__ + "img/dress.04df0dcf.jpg";